<template>
	<div class="md-layout" id="top">
		<div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
			<simple-wizard
				v-bind:name="name"
				v-bind:description="description"
				v-bind:jobType="jobType"
				v-bind:education="education"
				v-bind:experience="experience"
				v-bind:industryCategory="industryCategory"
				v-bind:jobCategory="jobCategory"
				v-bind:programme="programme"
				v-bind:skills="skills"
				v-bind:location="location"
				v-bind:deadline="deadline"
				v-bind:daysOfTheWeek="daysOfTheWeek"
				v-bind:hours="hours"
				v-bind:applicationDeadline="applicationDeadline"
				v-bind:budget="budget"
				v-bind:benefit="benefit"
				v-bind:address="address || ''"
				v-bind:citizenship="citizenship"
				v-bind:writtenSubmission="writtenSubmission"
				v-bind:writtenSubmissionDescription="writtenSubmissionDescription"
				v-bind:videoSubmission="videoSubmission"
				v-bind:videoSubmissionDescription="videoSubmissionDescription"
			>
				<template slot="header">
					<md-button class="btn-next md-success" @click="back">Save Changes</md-button>
					<p></p>
					<h3 class="title">Edit a Job</h3>
					<h5 class="category">This information you fill out will allow students to apply for the job</h5>
				</template>

				<wizard-tab :before-change="() => validateStep('step1')">
					<template slot="label">
						<div class="pc-view">Description</div>
						<div class="mobi-view"><i class="fas fa-list-ul"></i></div>
					</template>
					<first-step
						ref="step1"
						@on-validated="onStepValidated"
						@name="addName"
						@description="addDescription"
						@education="addEducation"
						@experience="addExperience"
						@jobType="addJobType"
						@industryCategory="addIndustryCategory"
						@jobCategory="addJobCategory"
						@skills="addSkills"
						@citizenship="addCitizenship"
						@programme="addProgramme"
					>
					</first-step>
				</wizard-tab>

				<wizard-tab :before-change="() => validateStep('step2')">
					<template slot="label">
						<div class="pc-view">Location</div>
						<div class="mobi-view"><i class="fas fa-location-arrow"></i></div>
					</template>
					<second-step
						ref="step2"
						@on-validated="onStepValidated"
						@location="addLocation"
						@deadline="addDeadline"
						@daysOfTheWeek="addDaysOfTheWeek"
						@hours="addHours"
						@applicationDeadline="addApplicationDeadline"
						v-bind:jobType="jobType"
						@address="addAddress"
					>
					</second-step>
				</wizard-tab>

				<wizard-tab :before-change="() => validateStep('step3')">
					<template slot="label">
						<div class="pc-view">Salary</div>
						<div class="mobi-view"><i class="fas fa-wallet"></i></div>
					</template>
					<third-step ref="step3" @on-validated="onStepValidated" @budget="addBudget" @benefit="addBenefit" v-bind:jobType="jobType"> </third-step>
				</wizard-tab>

				<wizard-tab :before-change="() => validateStep('step4')">
					<template slot="label">
						<div class="pc-view">Additional Submissions</div>
						<div class="mobi-view"><i class="fas fa-tasks"></i></div>
					</template>
					<fourth-step
						ref="step4"
						@writtenSubmission="addWrittenSubmission"
						@writtenSubmissionDescription="addWrittenSubmissionDescription"
						@videoSubmission="addVideoSubmission"
						@videoQuestion="addVideoQuestion"
						@on-validated="onStepValidated"
					>
					</fourth-step>
				</wizard-tab>
				<wizard-tab :before-change="() => validateStep('step5')">
					<template slot="label">
						<div class="pc-view">Review</div>
						<div class="mobi-view"><i class="fas fa-tasks"></i></div>
					</template>
					<fifth-step
						ref="step5"
						v-bind:name="name"
						v-bind:description="description"
						v-bind:jobType="jobType"
						v-bind:education="education"
						v-bind:experience="experience"
						v-bind:industryCategory="industryCategory"
						v-bind:jobCategory="jobCategory"
						v-bind:skills="skills"
						v-bind:location="location"
						v-bind:deadline="deadline"
						v-bind:daysOfTheWeek="daysOfTheWeek"
						v-bind:hours="hours"
						v-bind:applicationDeadline="applicationDeadline"
						v-bind:budget="budget"
						v-bind:benefit="benefit"
					>
					</fifth-step>
				</wizard-tab>
			</simple-wizard>
		</div>
	</div>
</template>
<script>
import FirstStep from './wizard/formSteps/FirstStep.vue';
import SecondStep from './wizard/formSteps/SecondStep.vue';
import ThirdStep from './wizard/formSteps/ThirdStep.vue';
import FourthStep from './wizard/formSteps/FourthStep.vue';
import FifthStep from './wizard/formSteps/FifthStep.vue';
import swal from 'sweetalert2';
import { WizardTab } from '@/components';
import SimpleWizard from './wizard/Wizard.vue';
import { mapActions } from 'vuex';
import db from '@/firebase/init';

export default {
	components: {
		FirstStep,
		SecondStep,
		ThirdStep,
		FourthStep,
		FifthStep,
		SimpleWizard,
		WizardTab,
	},
	data() {
		return {
			address: null,
			wizardModel: {},
			name: null,
			description: null,
			industryCategory: null,
			jobType: null,
			education: null,
			experience: null,
			jobCategory: null,
			programme: null,
			skills: [],
			location: null,
			deadline: null,
			daysOfTheWeek: null,
			hours: null,
			applicationDeadline: null,
			budget: null,
			benefit: null,
			citizenship: [],
			writtenSubmission: null,
			writtenSubmissionDescription: null,
			videoSubmission: null,
			videoSubmissionDescription: null,
		};
	},
	methods: {
		...mapActions(['updateJobDetails']),
		back() {
			if (this.skills.length !== 5) {
				this.$notify({
					message: 'Please select five required skills.',
					icon: 'error_outline',
					horizontalAlign: 'center',
					verticalAlign: 'top',
					type: 'danger',
				});
				return;
			}
			this.saveJobDetails();

			this.$router.go(-1);
		},
		saveJobDetails() {
			if (this.skills.length !== 5) {
				this.$notify({
					message: 'Please select five required skills.',
					icon: 'error_outline',
					horizontalAlign: 'center',
					verticalAlign: 'top',
					type: 'danger',
				});
				return;
			}
			this.updateJobDetails({
				id: this.$route.params.id,
				name: this.name,
				description: this.description,
				jobType: this.jobType,
				education: this.education,
				experience: this.experience,
				industryCategory: this.industryCategory,
				jobCategory: this.jobCategory,
				skills: this.skills,
				programme: this.programme,
				location: this.location,
				address: this.address,
				deadline: this.deadline,
				hours: this.hours,
				daysOfTheWeek: this.daysOfTheWeek,
				applicationDeadline: this.applicationDeadline,
				budget: this.budget,
				price: this.price,
				total: this.total(),
				citizenship: this.citizenship,
				additionalSubmissions: {
					writtenSubmission: this.writtenSubmission,
					writtenSubmissionDescription: this.writtenSubmissionDescription,
					videoSubmission: this.videoSubmission,
					videoSubmissionDescription: this.videoSubmissionDescription,
				},
			});
			this.$notify({
				message: 'Your data has been saved!',
				icon: 'add_alert',
				horizontalAlign: 'center',
				verticalAlign: 'top',
				type: 'success',
			});
		},
		total() {
			let total = (this.budget * (1 + this.price.serviceFee) + this.price.facilitationFee).toFixed(2);
			return total;
		},
		validateStep(ref) {
			return this.$refs[ref].validate();
		},
		onStepValidated(validated, model) {
			this.wizardModel = { ...this.wizardModel, ...model };
		},
		addvideoQuestion(questions) {
			this.videoSubmissionDescription = questions;
		},
		addName: function (name) {
			this.name = name;
		},
		addDescription: function (description) {
			this.description = description;
		},
		addJobType: function (jobType) {
			this.jobType = jobType;
		},
		addEducation: function (education) {
			this.education = education;
		},
		addExperience: function (experience) {
			this.experience = experience;
		},
		addProgramme: function (programme) {
			this.programme = programme;
		},
		addJobCategory: function (jobCategory) {
			this.jobCategory = jobCategory;
		},
		addIndustryCategory: function (industryCategory) {
			this.industryCategory = industryCategory;
		},
		addSkills: function (skills) {
			this.skills = skills;
		},
		addLocation: function (location) {
			this.location = location;
		},
		addDeadline: function (deadline) {
			this.deadline = deadline;
		},
		addDaysOfTheWeek: function (daysOfTheWeek) {
			this.daysOfTheWeek = daysOfTheWeek;
		},
		addHours: function (hours) {
			this.hours = hours;
		},
		addApplicationDeadline: function (applicationDeadline) {
			this.applicationDeadline = applicationDeadline;
		},
		addBudget: function (budget) {
			this.budget = budget;
		},
		addBenefit: function (benefit) {
			this.benefit = benefit;
		},
		addAddress: function (address) {
			this.address = address;
		},
		addCitizenship: function (citizenship) {
			this.citizenship = citizenship;
		},
		addWrittenSubmission: function (writtenSubmission) {
			this.writtenSubmission = writtenSubmission;
		},
		addWrittenSubmissionDescription: function (writtenSubmissionDescription) {
			this.writtenSubmissionDescription = writtenSubmissionDescription;
		},
		addVideoSubmission: function (videoSubmission) {
			this.videoSubmission = videoSubmission;
		},
		addVideoQuestion: function (videoQuestion) {
			this.videoSubmissionDescription = videoQuestion;
		},
	},
	created() {
		let businessModel = db.collection('Settings').doc('Business Model');
		businessModel.get().then(doc => {
			this.price = doc.data();
		});
	},
};
</script>
<style scoped>
@media only screen and (max-width: 768px) {
	.pc-view {
		display: none;
	}
	.md-layout-item.md-xsmall-size-80 {
		min-width: 100%;
		overflow-x: hidden;
	}
	.md-card-wizard .nav-pills > li i {
		font-size: 0px;
	}
}

@media only screen and (min-width: 768px) {
	.mobi-view {
		display: none;
	}
}
</style>
